import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultMethodResource,
    MethodMutationResourceSchema,
    useMethodActions,
} from '../../../../../resource/resources/artifacts/method/methodResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { MethodContent } from './MethodContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const MethodView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const methodActions = useMethodActions()
    const methodQuery = methodActions.useGetResource(id);
    const updateMethod = methodActions.useUpdateResource();
    const validateMethod = methodActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: MethodMutationResourceSchema,
        defaultValues: defaultMethodResource,
        submitHandler: async (data) => {
            await updateMethod.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: methodQuery.data,
    });

    return (
        <QueryBaseComponent name="Method" query={methodQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateMethod.data}
                    metaDataInfo={methodQuery.data}
                    resourceType={ResourceType.METHOD}
                >
                    <Text c="dimmed">Method</Text>
                </ResourceValidationTitleBar>
                <MethodContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
